import React, { useEffect, useState } from "react";
import { getApiBaseUrl, GET_BLOCKS } from "../Config/Config";
import { Link } from "react-router-dom";
import Table from "../../../core/pagination/datatable";
import { Select, Spin } from "antd";

const Blocks = () => {
  const { Option } = Select;
  const [blocks, setBlocks] = useState([]);
  const [ahuLoading, setAhuLoading] = useState(false);
  const [dryerLoading, setDryerLoading] = useState(false);
  const [washLoading, setWashLoading] = useState(false);
  const [selectedBlock, setSelectedBlock] = useState(0);
  const [ahuList, setAhuList] = useState([]);
  const [dryerEquipList, setDryerEquipList] = useState([]);
  const [washEquipList, setWashEquipList] = useState([]);

  const fetchBlocks = async () => {
    try {
      const response = await fetch(`${getApiBaseUrl()}${GET_BLOCKS}`);
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      const result = await response.json();
      const blockData = result?.ResultData || [];
      setBlocks(blockData);
    } catch (err) {
      console.error("Failed to fetch blocks:", err);
    }
  };

  useEffect(() => {
    fetchBlocks();
  }, []);

  const handleLocationChange = (value) => {
    setSelectedBlock(value);
  };

  const fetchAHUList = async (blockId) => {
    try {
      setAhuLoading(true);
      const res = await fetch(
        `${getApiBaseUrl()}/api/getAHUList?location=${blockId}`
      );
      const result = await res.json();
      setAhuList(result?.ResultData || []);
    } catch (err) {
      console.error("Failed to fetch AHU list:", err);
    } finally {
      setAhuLoading(false);
    }
  };

  useEffect(() => {
    fetchAHUList(selectedBlock);
  }, [selectedBlock]);

  const fetchDryerEquipList = async (blockId) => {
    try {
      setDryerLoading(true);
      const res = await fetch(
        `${getApiBaseUrl()}/api/getEquipments?Isdryer=1&blockid=${blockId}`
      );
      const result = await res.json();
      setDryerEquipList(result?.ResultData || []);
    } catch (err) {
      console.error("Failed to fetch Dryer Equipments:", err);
    } finally {
      setDryerLoading(false);
    }
  };

  useEffect(() => {
    fetchDryerEquipList(selectedBlock);
  }, [selectedBlock]);

  const fetchWashEquipList = async (blockId) => {
    try {
      setWashLoading(true);
      const res = await fetch(
        `${getApiBaseUrl()}/api/getEquipments?Isdryer=0&blockid=${blockId}`
      );
      const result = await res.json();
      setWashEquipList(result?.ResultData || []);
    } catch (err) {
      console.error("Failed to fetch Wash Equipments:", err);
    } finally {
      setWashLoading(false);
    }
  };
  useEffect(() => {
    fetchWashEquipList(selectedBlock);
  }, [selectedBlock]);

  const AHUcolumns = [
    {
      title: "AHU ID",
      dataIndex: "Code",
      key: "Code",
      sorter: (a, b) => (a.Code || "").localeCompare(b.Code || ""),
    },
    {
      title: "Description",
      dataIndex: "Description",
      key: "Description",
      sorter: (a, b) =>
        (a.Description || "").localeCompare(b.Description || ""),
      render: (text) => (
        <span title={text}>
          {text?.length > 15 ? `${text.slice(0, 15)}...` : text}
        </span>
      ),
    },

    {
      title: "Department",
      dataIndex: "Department",
      key: "Department",
      sorter: (a, b) => (a.Department || "").localeCompare(b.Department || ""),
    },
    {
      title: "Manufacturer",
      dataIndex: "Manufacturer",
      key: "Manufacturer",
      sorter: (a, b) =>
        (a.Manufacturer || "").localeCompare(b.Manufacturer || ""),
    },
    {
      title: "Model No",
      dataIndex: "ModelNo",
      key: "ModelNo",
      sorter: (a, b) => (a.ModelNo || "").localeCompare(b.ModelNo || ""),
    },
    {
      title: "Capacity",
      dataIndex: "Capacity",
      key: "Capacity",
      sorter: (a, b) =>
        (parseFloat(a.Capacity) || 0) - (parseFloat(b.Capacity) || 0),
    },
    {
      title: "No. of Filters",
      dataIndex: "Sparescount",
      key: "Sparescount",
      sorter: (a, b) =>
        (parseInt(a.Sparescount) || 0) - (parseInt(b.Sparescount) || 0),
    },
  ];

  const washEqpColumns = [
    {
      title: "Equipment Name",
      dataIndex: "EquipmentName",
      key: "EquipmentName",
      sorter: (a, b) => a.EquipmentName.localeCompare(b.EquipmentName),
    },
    {
      title: "Serial Number",
      dataIndex: "SerialNumber",
      key: "SerialNumber",
      sorter: (a, b) => a.SerialNumber.localeCompare(b.SerialNumber),
    },
    {
      title: "Block",
      dataIndex: "locatinname",
      key: "locatinname",
      sorter: (a, b) => a.locatinname.localeCompare(b.locatinname),
    },
    {
      title: "Status",
      dataIndex: "IsActive",
      key: "IsActive",
      render: (isActive) => (
        <span className={`badge ${isActive ? "bg-success" : "bg-danger"}`}>
          {isActive ? "Active" : "Inactive"}
        </span>
      ),
      sorter: (a, b) => a.IsActive - b.IsActive,
    },
  ];

  const DryerEqpColumns = [
    {
      title: "Equipment Name",
      dataIndex: "EquipmentName",
      key: "EquipmentName",
      sorter: (a, b) => a.EquipmentName.localeCompare(b.EquipmentName),
    },
    {
      title: "Serial Number",
      dataIndex: "SerialNumber",
      key: "SerialNumber",
      sorter: (a, b) => a.SerialNumber.localeCompare(b.SerialNumber),
    },
    {
      title: "Block",
      dataIndex: "locatinname",
      key: "locatinname",
      sorter: (a, b) => a.locatinname.localeCompare(b.locatinname),
    },
    {
      title: "Status",
      dataIndex: "IsActive",
      key: "IsActive",
      render: (isActive) => (
        <span className={`badge ${isActive ? "bg-success" : "bg-danger"}`}>
          {isActive ? "Active" : "Inactive"}
        </span>
      ),
      sorter: (a, b) => a.IsActive - b.IsActive,
    },
  ];

  return (
    <>
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="add-item d-flex">
              <div className="page-title">
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/assetmgt/dashboard">
                        <i className="fas fa-home fa-lg" />
                      </Link>
                    </li>
                    <h4 className="breadcrumb-item " aria-current="page">
                      Blocks
                    </h4>
                  </ol>
                </nav>
                {/* <h6>Manage Dryer Equipment</h6> */}
              </div>
            </div>
          </div>

          <div className="card table-list-card">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3  ">
              <div className="search-set mt-4"></div>
              <div className="d-flex table-dropdown my-xl-auto right-content align-items-center flex-wrap row-gap-3">
                <div style={{ minWidth: "250px" }}>
                  <label className="fw-bold mb-1 d-block">Select Block:</label>
                  <Select
                    showSearch
                    placeholder="Select Location"
                    optionFilterProp="children"
                    value={selectedBlock}
                    onChange={handleLocationChange}
                    style={{ width: "100%" }}
                    filterOption={(input, option) =>
                      (option?.children ?? "")
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                  >
                    <Option value={0}>All</Option>
                    {blocks?.map((loc) => (
                      <Option key={loc.BlockId} value={loc.BlockId}>
                        {loc.BlockName}
                      </Option>
                    ))}
                  </Select>
                </div>
              </div>
            </div>
            <div className="card-body p-1">
              <ul className="nav nav-tabs nav-tabs-bottom mb-3">
                <li className="nav-item">
                  <Link
                    className="nav-link active"
                    to="#bottom-tab1"
                    data-bs-toggle="tab"
                  >
                    AHU List
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    className="nav-link"
                    to="#bottom-tab2"
                    data-bs-toggle="tab"
                  >
                    Wash Equipments
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    className="nav-link"
                    to="#bottom-tab3"
                    data-bs-toggle="tab"
                  >
                    Dryer Equipments
                  </Link>
                </li>
              </ul>
              <div className="tab-content">
                <div className="tab-pane show active" id="bottom-tab1">
                  {/* <h4 className="card-title">AHU List</h4> */}
                  <div className="table-responsive">
                    {ahuLoading ? (
                      <div className="text-center my-4">
                        <Spin size="large" />
                        <p>Loading data...</p>
                      </div>
                    ) : ahuList?.length > 0 ? (
                      <Table dataSource={ahuList} columns={AHUcolumns} />
                    ) : (
                      <p className="text-center my-4">No data available</p>
                    )}
                  </div>
                </div>
                <div className="tab-pane" id="bottom-tab2">
                  <div className="table-responsive">
                    {dryerLoading ? (
                      <div className="text-center my-4">
                        <Spin size="large" />
                        <p>Loading data...</p>
                      </div>
                    ) : dryerEquipList?.length > 0 ? (
                      <Table
                        dataSource={dryerEquipList}
                        columns={DryerEqpColumns}
                      />
                    ) : (
                      <p className="text-center my-4">No data available</p>
                    )}
                  </div>
                </div>
                <div className="tab-pane" id="bottom-tab3">
                  <div className="table-responsive">
                    {washLoading ? (
                      <div className="text-center my-4">
                        <Spin size="large" />
                        <p>Loading data...</p>
                      </div>
                    ) : washEquipList?.length > 0 ? (
                      <Table
                        dataSource={washEquipList}
                        columns={washEqpColumns}
                      />
                    ) : (
                      <p className="text-center my-4">No data available</p>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Blocks;
